'use client';

import type { Category } from '@eliadmin/core/src/api/slugs/types/slug-detail-types';
import {
  AttributeSideDynamic,
  AttributeSideDynamicAvailability,
} from '@eliadmin/core/src/components/categories/attributes/attribute';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useCategoryStore } from '@eliadmin/core/src/stores/category-store';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { IoClose } from 'react-icons/io5';
import CategorySortToggle from './category-sort-toggle';

type CategoryFilterTopProps = {
  categoryProp?: Category;
  className?: {
    collapsibleContent?: string;
    clearFilterButton?: string;
  };
};

export default function CategoryFilterTop({ categoryProp, className }: CategoryFilterTopProps) {
  const categoryStore = useCategoryStore(state => state.category);

  const category = categoryProp || categoryStore;
  const templateSettings = useGlobalStore(state => state.templateSettings);
  const clearFilters = useCategoryStore(s => s.clearFilters);

  const { t } = useTranslations();

  //TODO: Availability attribute

  return (
    <div className="hidden w-full items-center justify-between md:flex">
      <div className="flex w-full flex-wrap items-center justify-start gap-4">
        {/* attributes */}
        {!!templateSettings.category?.attributes_in_filter?.enabled &&
          category.attributes?.map(attribute => (
            <div
              key={`top-filter-attribute-${attribute.id}`}
              className={cn(
                `w-full max-w-[264px] border-b border-b-border order-${templateSettings.category?.attributes_in_filter?.order}`,
                'ea-category-filter-top__attributes-container',
              )}
            >
              <AttributeSideDynamic
                key={`attribute-${attribute.id}`}
                name={attribute.name}
                attribute={attribute}
                className={{ wrapper: cn('', 'ea-category-filter-top__attributes') }}
              />
            </div>
          ))}
        <div
          className={cn(
            `w-full max-w-[264px] border-b border-b-border order-${templateSettings.category?.attributes_in_filter?.order}`,
            'ea-category-filter-top__attributes-container',
          )}
        >
          <AttributeSideDynamicAvailability
            name={t('text339')}
            availabilities={category.availabilities}
            className={{ wrapper: cn('', 'ea-category-filter-top__availabilities') }}
          />
        </div>
        <CategorySortToggle />
      </div>

      <button
        type="button"
        onClick={clearFilters}
        className={cn(
          'flex h-[52px] cursor-pointer items-center justify-center gap-2 whitespace-nowrap border-none px-6 font-heading text-lg font-normal  uppercase text-[#999999] text-primary',
          'ea-category-filter-top__clear-filter-button',
          className?.clearFilterButton,
        )}
      >
        <IoClose size={24} />
        ZRUŠIŤ FILTER
      </button>
    </div>
  );
}
